module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-bar"
  }, [(_vm.tips.length > 0) ? _c('div', {
    staticClass: "stat-prompt-panel"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [(_vm.tipsExpanded) ? _c('div', _vm._l((_vm.tips), function(tip, tipId) {
    return _c('div', {
      staticClass: "prompt mdl-card__supporting-text",
      class: tip.name
    }, [_c('p', [_vm._v("\n            " + _vm._s(tip.text) + "\n          ")]), _vm._v(" "), (tip.filter) ? _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
      on: {
        "click": function($event) {
          _vm.$emit('showTip', tip)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.i18n().tipApplyFilter) + "\n          ")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (!_vm.tipsExpanded) ? _c('div', [_c('div', {
    staticClass: "mdl-card__supporting-text summary"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().tipsSummary(_vm.tips.length)) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tipsHideButton"
  }, [(_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:tipsExpanded', false); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_less")])]) : _vm._e(), _vm._v(" "), (!_vm.tipsExpanded) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.$emit('update:tipsExpanded', true); }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.enableFilter) ? _c('div', {
    staticClass: "filterHolder"
  }, [_c('TopFilterExpression', {
    attrs: {
      "expression": _vm.filter,
      "columns": _vm.calculatedColumnNames,
      "applied": !!_vm.appliedFilter,
      "filterExpanded": _vm.filterExpanded
    },
    on: {
      "update:expression": _vm.handleFilterUpdate,
      "apply": function($event) {
        _vm.$emit('applyFilter')
      },
      "update": function($event) {
        _vm.$emit('updateFilter')
      },
      "clear": function($event) {
        _vm.$emit('clearFilter')
      },
      "update:filterExpanded": function (value) { return _vm.$emit('update:filterExpanded', value); }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411f1f3d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/query/TopBar.vue
// module id = 442
// module chunks = 0